<template>
  <div class="settings-template-editor d-flex flex-column m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">{{ name }}</h5>
    </div>
    <b-form-textarea v-model="editorValue" class="flex-grow-1" />

    <div class="d-flex justify-content-end pt-3">
      <b-button
        class="pt-2 pb-2"
        size="sm"
        variant="primary"
        :disabled="error"
        @click="save"
      >
        Save changes
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import systemSettingServer from "../../server/systemSetting";
import { formatDateTimeMysql } from "../../helpers/date";

export default {
  name: "FormBuilderTemplateEditor",
  props: ["name", "property"],
  data() {
    return {
      /* EForms props */
      patient,
      document,
      client: episodeOfCare,
      vitals: [],
      form: {
        name: "Form name",
        createdAt: formatDateTimeMysql(threeDaysAgo)
      },
      /* Groups props */
      group: {
        creationDate: formatDateTimeMysql(aMonthAgo),
        startDate: formatDateTimeMysql(twoMonthsAgo),
        endDate: formatDateTimeMysql(aMonthAgo),
        topicDetails: "Topic details",
        noParticipants: 10,
        noCompleted: 8,
        facilitator: user
      },
      participant: {
        patient,
        episodeOfCare,
        document,
        completed: true
      },
      fullPath: [
        { id: 1, type: "Parent Group Type" },
        { id: 2, type: "Child Group Type" }
      ],
      /* This props */
      template: null,
      error: false
    };
  },
  mounted() {
    this.editorValue = this.systemSetting[this.property];
  },
  methods: {
    ...mapActions("layout", ["fetchSystemSetting", "showAlertSuccess"]),
    save: async function() {
      await systemSettingServer.update({
        [this.property]: this.editorValue
      });
      await this.fetchSystemSetting();

      this.showAlertSuccess();
    },
    validateHTML: function(html) {
      html = html.replace(/<[^>]*\/\s?>/g, ""); // Remove all self closing tags
      html = html.replace(/<(br|hr|img).*?>/g, ""); // Remove all <br>, <hr>, and <img> tags
      const openingTags = html.match(/<[^/^>]+>/g) || []; // Get remaining opening tags
      const closingTags = html.match(/<\/[^<>]*>/g) || []; // Get remaining closing tags

      return openingTags.length === closingTags.length ? true : false;
    }
  },
  computed: {
    ...mapState("layout", {
      systemSetting: state => state.systemSetting
    }),
    editorValue: {
      get() {
        return this.template;
      },
      set(newValue) {
        if (this.validateHTML(newValue)) {
          this.error = false;
          this.template = newValue;
        } else {
          this.error = true;
        }
      }
    }
  }
};

const MILLISECONDS_IN_DAY = 86400000;
const nowUTC = new Date().getTime() + new Date().getTimezoneOffset() * 60000;
const threeDaysAgo = nowUTC - MILLISECONDS_IN_DAY * 3;
const aMonthAgo = nowUTC - MILLISECONDS_IN_DAY * 30;
const twoMonthsAgo = nowUTC - MILLISECONDS_IN_DAY * 60;
const twentyFourYearsAgo = nowUTC - MILLISECONDS_IN_DAY * 365 * 24;
const user = {
  id: "User Id",
  name: "User name",
  email: "User email",
  phone: "User phone",
  status: "User status"
};
const patient = {
  id: "Patient Id",
  firstName: "Patient",
  lastName: "Name",
  email: "Patient Email",
  mrn: "MRN",
  dateOfBirth: formatDateTimeMysql(twentyFourYearsAgo),
  phone: "Patient phone",
  ssn: "Patient ssn",
  zipcode: "Patient zipcode"
};
const episodeOfCare = {
  patient,
  eocn: "Mrn Suffix",
  startDate: formatDateTimeMysql(twoMonthsAgo),
  endDate: formatDateTimeMysql(nowUTC),
  status: "EOC Status"
};
const document = {
  createdAt: formatDateTimeMysql(threeDaysAgo),
  createdBy: user,
  effectiveDate: formatDateTimeMysql(threeDaysAgo),
  status: "Doc Status"
};
</script>

<style>
.settings-template-editor {
  height: calc(100vh - 214px);
}
</style>
